module.exports = __webpack_public_path__ + "static/media/thumb.ed8b32c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/crescent-extension/thumb.jpg
// module id = 42
// module chunks = 0